import React from "react";
import "./Simulationheadercdmqb.css";
// All classNames are suffixed with "CDMQB" so they never collide with the
// default skin's CSS if that stylesheet happens to be loaded too.

export default function SimulationHeaderCDMQB(props) {
  const formatTimeRemaining = (timeRemaining) => {
    let hours = Math.floor(timeRemaining / 3600);
    let minutes = Math.floor(timeRemaining / 60);
    let seconds = timeRemaining % 60;

    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    return `${hours}:${minutes}:${seconds}`;
  };

  const getTimerSpeedDisplay = () => {
    const speed = props.timerSpeed || "1x";
    return speed !== "1x" ? ` (${speed})` : "";
  };

  return (
    <div id="headerContainer">
      {/* =====================================================
          TITLE BAR
          ===================================================== */}
      <div className="simulationHeaderContainerCDMQB">
        <div className="simulationHeaderLeftContentWrapperCDMQB">
          <h3 className="simulationHeaderTextCDMQB">
            Question {props.currentQuestion} of{" "}
            {props.simulationData.TOTALNUMQUESTIONS}
          </h3>
        </div>

        <div className="simulationHeaderCenterContentCDMQB">
          <h3 className="simulationHeaderTextCDMQB">CDM Practice Exam</h3>
        </div>

        <div className="simulationHeaderRightContentWrapperCDMQB">
          <h3 className="simulationHeaderTextCDMQB">
            Time remaining for this session:
          </h3>
          {props.timedExam ? (
            <h3 className="simulationHeaderTextCDMQB">
              {formatTimeRemaining(props.timeRemaining)}
              {getTimerSpeedDisplay()}
            </h3>
          ) : (
            <h3 className="simulationHeaderTextCDMQB">Untimed</h3>
          )}
        </div>
      </div>

      {/* =====================================================
          TOOLBAR
          ===================================================== */}
      <div className="simulationHeaderToolbarCDMQB">
        <div className="simulationHeaderToolbarToolsCDMQB">
          {!props.settings.originalLabInstruction && (
            <button
              className="simulationHeaderTextButtonCDMQB"
              onClick={props.displayInstructions}
              title="Instructions"
            >
              <img
                className="simulationHeaderInstructionsIconCDMQB"
                src="/exhibit.png"
                alt=""
                draggable={false}
              />
              Instructions
            </button>
          )}

          <button
            type="button"
            className={`simulationHeaderTextButtonCDMQB simulationHeaderSpriteButtonCDMQB simulationHeaderFeedbackButtonCDMQB ${
              props.feedbackOpen ? "activeCDMQB" : ""
            }`}
            onClick={props.showFeedback}
            aria-haspopup="dialog"
            aria-expanded={!!props.feedbackOpen}
            title="Report Bug/Feedback"
          >
            Feedback
          </button>

          <div className="simulationHeaderTextControlsCDMQB">
            <button
              className={`simulationHeaderTextButtonCDMQB ${
                props.textEditModes.highlight ? "activeCDMQB" : ""
              }`}
              onClick={props.toggleHighlight}
              title="Highlight selected text (Alt+H)"
            >
              Highlight (Alt + H)
            </button>

            <button
              id="abe-StrikethroughButtonCDMQB"
              className={`simulationHeaderTextButtonCDMQB simulationHeaderSpriteButtonCDMQB simulationHeaderStrikethroughButtonCDMQB ${
                props.textEditModes.strikeThrough ? "activeCDMQB" : ""
              }`}
              onClick={props.toggleStrikeThrough}
              title="Strikethrough selected text (Alt+S)"
            >
              Strikethrough (Alt + S)
            </button>
          </div>

          <button
            className={`simulationHeaderTextButtonCDMQB simulationHeaderCalculatorButtonCDMQB ${
              props.calculatorOpen ? "activeCDMQB" : ""
            }`}
            onClick={props.displayCalculator}
            aria-pressed={!!props.calculatorOpen}
          >
            Calculator
          </button>
        </div>

        {/* Right-hand group: color scheme dropdown (where it's always
            been), Settings, then Lab Panels as the last option. */}
        <div className="simulationHeaderToolbarFlagsCDMQB">
          <div className="simulationHeaderColorSchemeDropDownCDMQB">
            <label htmlFor="colorSchemesCDMQB" className="srOnlyCDMQB">
              Color Scheme
            </label>
            <select
              id="colorSchemesCDMQB"
              className="simulationHeaderColorSchemeSelectCDMQB"
              value={props.colorScheme}
              onChange={(e) => props.setColorScheme(e.target.value)}
              style={{
                backgroundColor:
                  props.activeColorScheme?.background || undefined,
                color: props.activeColorScheme?.text || undefined,
              }}
            >
              {(props.colorSchemes || []).map((scheme) => (
                <option key={scheme.id} value={scheme.id}>
                  {scheme.label}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            className={`simulationHeaderTextButtonCDMQB ${
              props.settingsOpen ? "activeCDMQB" : ""
            }`}
            onClick={props.openSettings}
            aria-haspopup="dialog"
            aria-expanded={!!props.settingsOpen}
            title="Settings"
          >
            <svg
              className="simulationHeaderToolbarIconCDMQB"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M19.14 12.94a7.43 7.43 0 0 0 .06-.94 7.43 7.43 0 0 0-.06-.94l2.03-1.58a.48.48 0 0 0 .12-.61l-1.92-3.32a.48.48 0 0 0-.59-.21l-2.39.96a7.1 7.1 0 0 0-1.62-.94l-.36-2.54A.47.47 0 0 0 13.93 2h-3.86a.47.47 0 0 0-.47.4l-.36 2.54a7.36 7.36 0 0 0-1.62.94l-2.39-.96a.48.48 0 0 0-.59.21L2.72 8.45a.47.47 0 0 0 .12.61l2.03 1.58a7.43 7.43 0 0 0-.06.94c0 .32.02.63.06.94l-2.03 1.58a.48.48 0 0 0-.12.61l1.92 3.32c.12.21.37.3.59.21l2.39-.96c.5.38 1.04.7 1.62.94l.36 2.54c.04.23.24.4.47.4h3.86c.23 0 .43-.17.47-.4l.36-2.54a7.36 7.36 0 0 0 1.62-.94l2.39.96c.22.09.47 0 .59-.21l1.92-3.32a.48.48 0 0 0-.12-.61l-2.03-1.58zM12 15.6A3.6 3.6 0 1 1 12 8.4a3.6 3.6 0 0 1 0 7.2z" />
            </svg>
            Settings
          </button>

          {!props.settings.originalLabInstruction && (
            <button
              type="button"
              className="simulationHeaderTextButtonCDMQB"
              onClick={props.displayLabPanels}
              title="Lab Panels"
            >
              <svg
                className="simulationHeaderToolbarIconCDMQB"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M9 2v2h1v6.4L4.6 19.2A2 2 0 0 0 6.3 22h11.4a2 2 0 0 0 1.7-2.8L14 10.4V4h1V2H9z" />
              </svg>
              Lab Panels
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
